import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { COUNTRY } from "../../constants";
import "./styles.scss";

const InfoKeyValueCard = ({
  data = [],
  hasColon,
  hasGrandTotal,
  backgroundColor,
  labelTextSize,
  valueTextSize,
  labelTextColor,
  isDynamicLabel,
  heading,
  rightIcon,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const calculateTotals = () => {
    let total = 0;

    data.forEach((item) => {
      const amount = Number(item.value || 0);
      total += amount;
    });

    return { total };
  };

  const getValue = (value) => {
    if (!value || (typeof value === "string" && !value.trim())) {
      return "--";
    }
    if (typeof value === "string") {
      if (value.includes(COUNTRY.SAUDI_ARABIA.CURRENCY_CODE)) {
        const numericString = value.replace(/[^\d.-]/g, "");
        const numericValue = parseFloat(numericString);
        return isNaN(numericValue) ? (
          value
        ) : (
          <div className="saudi-riyal-wrapper">
            <span className="icon-saudi_riyal"></span>
            <span>{numericValue.toLocaleString()}</span>
          </div>
        );
      }
    }
    return value;
  };

  useEffect(() => {
    calculateTotals();
  }, []);

  return (
    <div
      className="info-key-value-card"
      style={{ backgroundColor: `var(--bs-${backgroundColor})` }}
    >
      {rightIcon || heading ? (
        <div className="info-key-value-card-heading-container">
          {rightIcon ? (
            <div className="info-key-value-card-icon-container">
              <img
                src={rightIcon}
                alt="right icon"
                className="info-key-value-card-icon"
              />
            </div>
          ) : null}
          {heading ? (
            <p className="info-key-value-card-heading">
              {t(`${routeName}.${heading}`)}
            </p>
          ) : null}
        </div>
      ) : null}
      {data &&
        data.map((item, index) => {
          const isLastItem = index === data.length - 1;
          const isLastItemGrandTotal = isLastItem && hasGrandTotal;
          return (
            <div
              className="info-key-value-card-item"
              style={{
                marginBottom: isLastItem && 0,
                marginTop: isLastItemGrandTotal && "1rem",
              }}
            >
              <div>
                <span
                  className="info-key-value-card-label"
                  style={{
                    fontSize: isLastItemGrandTotal
                      ? "1rem"
                      : `${labelTextSize}px`,
                    color: `var(--bs-${
                      isLastItemGrandTotal ? "neutral-900" : labelTextColor
                    })`,
                    fontWeight: isLastItemGrandTotal && "bold",
                  }}
                >
                  {isDynamicLabel
                    ? item.label
                    : t(`${routeName}.${item.label}`)}
                  {hasColon ? ":" : ""}
                </span>
                {item?.selectedItemCount ? (
                  <span className="selected-item-count">
                    {item?.selectedItemCount}
                  </span>
                ) : null}
              </div>

              <span
                className="info-key-value-card-value"
                style={{ fontSize: `${valueTextSize}px` }}
              >
                {item?.isTotal
                  ? getValue(
                      `${COUNTRY.SAUDI_ARABIA.CURRENCY_CODE} ${
                        calculateTotals().total
                      }`
                    )
                  : getValue(item.value)}
              </span>
            </div>
          );
        })}
    </div>
  );
};

export default InfoKeyValueCard;
